var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container catalog-page" },
    [
      _c("block-breadcrumbs"),
      _c("banners-slot", {
        staticClass: "bottom-offset",
        attrs: { "slot-name": "transparency_category" }
      }),
      _c("page-head", {
        staticClass: "catalog-page__head",
        attrs: { title: _vm.CATEGORY_NAME, info: _vm.subtitle }
      }),
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("side-nav"),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("banners-slot", {
                staticClass: "bottom-offset",
                attrs: { "slot-name": "rowbanner2_category" }
              }),
              _c("product-gallery-slot", {
                staticClass: "bottom-offset",
                attrs: { "slot-name": "new_category" }
              }),
              _c("category-banners-slot", { staticClass: "bottom-offset" }),
              _c("banners-slot", {
                staticClass: "bottom-offset",
                attrs: { "slot-name": "rowbanner1_category" }
              }),
              _c("product-gallery-slot", {
                staticClass: "bottom-offset",
                attrs: { "slot-name": "popular_category" }
              }),
              _c("banners-slot", {
                attrs: { "slot-name": "rowbanner3_category" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }